import CustomerDataTable from "@pages/customer/list/sub_components/customer_data_table"

export default function CustomerPage() {
  return <CustomerDataTable />
}
